import { ActivatedRoute, CanMatchFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { AppRoutePaths, AppRoutes } from "./shared/common/app-path.routes";
import { UsersService } from "./api/users.service";
export const authGuard: CanMatchFn = async () => {
  // return true;
  const router = inject(Router);
  const oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  const user = inject(UsersService);
  const isAuth = await oktaAuth.isAuthenticated();
  if (router.url.includes(AppRoutes.InternalUserRegistration)) {
    return true;
  }

  if (isAuth) {
    // If authenticated but access state is not yet loaded (e.g., after a refresh), hydrate it.
    try {
      await user.ensureHydrated();
      return true;
    } catch (error) {
      router.navigateByUrl(AppRoutePaths[AppRoutes.Login]);
      return false;
    }
  } else {
    router.navigateByUrl(AppRoutePaths[AppRoutes.Login]);
    return false;
  }
};
